import React, { useContext, useEffect, useState } from 'react';

import {
    Grid,
} from '@material-ui/core';

import { ContractForm } from './ContractForm';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { UserContext } from '../../../../contexts';

import { RequestStatus, ApplicationRoles } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: 20
    }
}));

export const ContractTab = (props) => {
    const classes = useStyles();

    const { 
        userInfo,
        isUserInRole, 
        isUserInRoles 
    } = useContext(UserContext);

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSubmitting
    } = useContext(TabsContext);

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(isSubmitting 
            || !(
                (state.request.status === RequestStatus.Logistic
                    && !state.request.isSignedContractReady
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRoles([ApplicationRoles.AOFOpener, ApplicationRoles.BossApprover]))
                ||
                (state.request.status === RequestStatus.WaitingForContract
                    && !state.request.isSignedContractReady
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRoles([ApplicationRoles.AOFOpener, ApplicationRoles.BossApprover]))
                ||
                (state.request.status === RequestStatus.WaitingToBeAddedInSap
                    && !state.request.isSignedContractAvailable
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRoles([ApplicationRoles.AOFOpener, ApplicationRoles.BossApprover]))
                ||
                (state.request.status === RequestStatus.Approved
                    && !state.request.isSignedContractAvailable
                    && state.request.ownerKey === userInfo.externalKey
                    && isUserInRoles([ApplicationRoles.AOFOpener, ApplicationRoles.BossApprover]))
                ||
                (state.request.status === RequestStatus.AccountReceivableApproval
                    && isUserInRole(ApplicationRoles.AccountReceivable))
            )
        );
    }, [state.request.status, state.request.ownerKey, userInfo.externalKey])

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xl={12} xs={12} md={12}>
                    <ContractForm disabled={disabled} />
                </Grid>
            </Grid>
        </div>
    );
}


